import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import rel from '@ifeng-fe/container_channel/common/client/utils/rel';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImage, formatUrl } from '@ifeng-fe/public_method';
import { formatTime } from '@ifeng-fe/container_channel/common/client/spring/utils/formatTime';

class MainTop extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        bolder: PropTypes.bool,
    };

    render() {
        const {
            content: { thumbnails, title, newsTime, url },
            bolder = false,
        } = this.props;

        return (
            <li className={`${styles.newsList} ${bolder ? styles.fontBolder : ''}`}>
                {thumbnails.image.length !== 0 ? (
                    <span>
                        <a href={formatUrl(url)} target="_blank" rel={rel} title={title}>
                            <img src={formatImage(thumbnails.image[0].url, 100, 62)} />
                        </a>
                    </span>
                ) : null}
                <h4>
                    <a href={formatUrl(url)} target="_blank" rel={rel} title={title}>
                        {title}
                    </a>
                </h4>
                {newsTime ? <em>{formatTime(newsTime)}</em> : null}
            </li>
        );
    }
}

export default errorBoundary(MainTop);
